
import LoaderImg from '../assests/tube-spinner.svg'

const Loader = () => {
    return (
        <span className='w-full h-full flex items-center justify-center'>
            <img src={LoaderImg} alt='loader' className="h-[35px] w-[35px]" color='red' />
        </span>
    )
}

export default Loader
